import { Link, useNavigate } from "react-router-dom";
import { Sparkles, Home, Users, Plus, X } from "lucide-react";
import { Button } from "../ui/button";
import { useLang } from "../../lib/LanguageContext";
import LanguageSwitcher from "./LanguageSwitcher";

const Sidebar = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const { t } = useLang();

  return (
    <>
      <div className={`fixed inset-0 bg-black/50 z-40 md:hidden transition-opacity ${isOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'}`} onClick={onClose} />
      <aside className={`sidebar ${isOpen ? 'open' : ''}`}>
        <div className="flex items-center justify-between mb-8">
          <div className="flex items-center gap-3">
            <Sparkles className="w-7 h-7 text-primary" />
            <span className="text-lg font-bold">AI Model Creator</span>
          </div>
          <button onClick={onClose} className="md:hidden text-text-secondary hover:text-white">
            <X className="w-6 h-6" />
          </button>
        </div>

        <nav className="space-y-2">
          <Link to="/" className="sidebar-link" data-testid="sidebar-home-link"><Home className="w-5 h-5" />{t('home')}</Link>
          <Link to="/dashboard" className="sidebar-link active" data-testid="sidebar-dashboard-link"><Users className="w-5 h-5" />{t('myModels')}</Link>
        </nav>

        <div className="mt-6 px-2">
          <LanguageSwitcher />
        </div>

        <div className="absolute bottom-6 left-6 right-6">
          <Button onClick={() => navigate('/models/new')} className="w-full bg-gradient-to-r from-primary to-secondary hover:opacity-90" data-testid="sidebar-new-model-btn">
            <Plus className="w-5 h-5 mr-2" />{t('newModel')}
          </Button>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;
